import React from 'react';
import ResetPasswordContainer from '../components/resetPassword.container';

const ResetPasswordPage: React.FC = () => <ResetPasswordContainer />;

export default ResetPasswordPage;
